import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { TabMenu } from 'primereact/tabmenu';
import { fetchTicket, fetchTickets, updateTicket } from '../apis/tickets';
import toast, { Toaster } from 'react-hot-toast';
import { Tag } from 'primereact/tag';
import { Sidebar } from 'primereact/sidebar';
import { fetchOrder, } from '../apis/orders';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Image } from 'primereact/image';
import { Panel } from 'primereact/panel';

export default function Tickets() {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const ticketLimit = 15;
  const [activeIndex, setActiveIndex] = useState(0);
  const [tickets, setTickets] = useState([]);
  const [order, setOrder] = useState();
  const [visible, setVisible] = useState(false);
  // const [selectedOrder, setSelectedOrder] = useState(null);

  const tabItems = [
    { label: 'Pending' },
    { label: 'Resolved' }
  ];

  const onPage = async (event) => {
    setFirst(event.first);
    setPage(event.page);
    try {
      await getTickets(event.page, activeIndex);
    } catch (error) {
      console.log(error);
    }
  };

  const getTickets = async (page, index) => {
    setLoading(true);

    try {

      const status = index === 0 ? 'true' : 'false';
      const tickets = await fetchTickets(page, status);
      // console.log(tickets);

      if (tickets.length !== 0) {
        // console.log(tickets[0]['size']);
        setTotalPage(parseInt(tickets[0]['size']));
      } else {
        setTotalPage(0);
      }
      setTickets(tickets);
    } catch (error) {
      console.error("Error fetching Vendors: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(activeIndex);
    getTickets(0, activeIndex);
  }, [activeIndex]);

  const resolveTicket = async (action, id) => {
    try {


      console.log(action);
      console.log(id);

      const data = await updateTicket(id, action);

      console.log('184 after update ticket');
      console.log(data);

      if (page > 0 && tickets.length === 15) {
        await getTickets(page - 1, activeIndex);
      } else {
        await getTickets(page, activeIndex);
      }
    } catch (error) {
      toast.error('Error verifying vendor');
    }
  };

  const onRowSelect = (event) => {
    setVisible(true);
    console.log('246 - row select');
    getOrder(event);
    // toast.current.show({ severity: 'info', summary: 'Product Selected', detail: `Name: ${event.data.username}`, life: 3000 });
  };

  const onRowUnselect = (event) => {
    setVisible(false);
    // setSelectedTicket(null);
    // // toast.current.show({ severity: 'warn', summary: 'Product Unselected', detail: `Name: ${event.data.username}`, life: 3000 });
  };

  const getOrder = async (e) => {
    console.log('135- Sidebar Opening');
    console.log(e);
    const orderId = e.data['orderId'];

    setLoading(true);

    if (e.data != null) {
      console.log('142');
      console.log(orderId);

      // setTimeout(async () => {
      const order = await fetchOrder(orderId);

      console.log('139 - after fetching order');
      console.log(order);

      console.log(typeof order);

      if (typeof order !== Object) {
        setOrder(null);
        console.log('93');
      }

      setOrder(order);
      // }, 5000);
    } else {
      // console.log(rowClick);
      console.log(e.data);
    }

    setLoading(false);
  }



  return (
    <>
      <Toaster />
      <div className="card">
        <h2 style={{ marginBlock: '1rem' }}>All Tickets</h2>
        <TabMenu
          model={tabItems}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          pt={{
            menu: { className: 'gap-2 mb-2' } // Tailwind: adds space between items
          }}
        />
        <DataTable value={tickets} lazy paginator rows={ticketLimit} totalRecords={totalPage} first={first} selectionMode={'checkbox'} onPage={onPage} loading={loading} emptyMessage={!loading && `No Tickets found`} tableStyle={{ minWidth: '50rem' }} selection={selectedTicket} onSelectionChange={(e) => setSelectedTicket(e.value)} onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} scrollable scrollHeight="80vh"
          paginatorTemplate="PrevPageLink NextPageLink CurrentPageReport"
          currentPageReportTemplate="Total Tickets: {totalRecords}"
        >

          <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
          <Column field="orderId" header="Order Id"></Column>
          <Column field="phoneNumber" header="Phone Number"></Column>
          <Column field="reason" header="Reason"></Column>
          <Column field="description" header="Description"></Column>
          <Column header="Action" body={(rowData) => (
            activeIndex == 0
              ?
              <Button icon="pi pi-check" label="Mark as Resolved" tooltip='Mark this ticket as resolved' size='small' severity="success" onClick={() => resolveTicket('true', rowData.ticketId)} />
              // <Tag>Resolved</Tag>

              :
              <Tag>Resolved</Tag>
          )} />
        </DataTable>
      </div >

      <Sidebar visible={visible} onHide={() => {
        setVisible(false);
        // setSelectedOrder(null);
        setSelectedTicket(null);
      }} position="right" style={{ width: '25rem' }}>
        <div className="p-4">
          <h2 className="mb-3 text-primary">🧾 Order Details</h2>

          {loading ? (
            <>
              < i className="pi pi-spin pi-cog" style={{ fontSize: '2rem' }}></i>
            </>

          ) : order ? (
            <>
              <div className="mb-3">
                <span className="font-bold text-900">Order ID: </span>
                <Tag value={order.orderId} severity="info" className="ml-2" />
              </div>

              <div className="mb-3">
                <span className="font-bold text-900">Total Amount: </span>
                <Tag value={`₹${order.orderTotal}`} severity="success" className="ml-2" />
              </div>
              <div className="mb-3">
                <span className="font-bold text-900">Sub Total: </span>
                <Tag value={`₹${order.subTotal}`} severity="success" className="ml-2" />
              </div>
              <div className="mb-3">
                <span className="font-bold text-900">Delivery Price: </span>
                <Tag value={`₹${order.deliveryPrice}`} severity="success" className="ml-2" />
              </div>
              {
                order.promoCode == null ? (
                  <div className="mb-3">
                    <span className="font-bold text-900">Promo Code: </span>
                    <Tag value={`None`} severity="success" className="ml-2" />
                  </div>
                ) : (
                  <div className="mb-3">
                    <span className="font-bold text-900">Promo Code: </span>
                    <Tag value={`₹${order.promoCode}`} severity="success" className="ml-2" />
                  </div>
                )
              }
              <div className="mb-3">
                <span className="font-bold text-900">Discount: </span>
                <Tag value={`₹${order.discount}`} severity="success" className="ml-2" />
              </div>
              <Divider />
              <Panel header='📍 Delivery Address' toggleable className="mb-3">
                <p className="m-0 text-700">
                  {order.address["House no / Flat / Building name"]}, {order.address["Locality / Area / Sector"]}, {order.address.City} - {order.address.Pincode}
                </p>
              </Panel>

              <Divider />
              <h3 className="mb-1 text-xl">🛍 Items</h3>

              <div className="flex flex-column gap-3">
                {order.orderProducts.map((item, index) => (
                  <Card key={index} className="p-0 border-round shadow-2">
                    <div className="flex align-items-center gap-3">
                      <Image
                        // src={`data:image/jpeg;base64,${item.productImage}`}
                        src={item.productImage}
                        alt={item.productName}
                        width="100"
                        onError={(e) => e.target.src = '/image.png'}
                      // preview
                      />
                      <div className="flex flex-column gap-1">
                        <span className="text-lg font-semibold text-900">{item.productName}</span>
                        <span className="text-sm text-700">
                          {item.productQuantity} x <Tag severity="warning" value={`${item.numberofItems} Items`}></Tag>
                        </span>
                        <span className="text-sm font-medium text-green-600">
                          ₹{item.productPrice} x {item.numberofItems} = ₹{item.total}
                        </span>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            </>
          ) : (<p>Not found</p>)}
        </div>
      </Sidebar >
    </>
  );
}

